import React, { useEffect, useState } from 'react';
import { addtoCart, fetchCategories, getBooksBySubcategory } from '../services/Apis'; // <-- Import the new API
import { Box, Button, Card, CardContent, CardMedia, Container, IconButton, Typography } from '@mui/material'
import Filter from '../common/Filter';
import { useNavigate, useLocation } from 'react-router-dom';
import useResponsive from '../hooks/useResponsive';
import { useFilter } from '../context/FilterContext';

const FilteredBooks = () => {
    const navigate = useNavigate();

    const { isSmallScreen } = useResponsive();
    const [books, setBooks] = useState([]);
    const [categoryName, setCategoryName] = useState(""); // <-- Add this

    // Get subCategoryId from query params
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const subCategoryId = params.get('subcat');
    const { token, isLoggedIn } = useFilter()
    useEffect(() => {
        const fetchBooks = async () => {
            try {
                if (subCategoryId) {
                    const booksData = await getBooksBySubcategory(subCategoryId);
                    setBooks(booksData);
                } else {
                    setBooks([]);
                }
            } catch (e) {
                setBooks([]);
            }
        };
        fetchBooks();
    }, [subCategoryId]);
   const handleBuyNow = async (book) => {
         if (isLoggedIn && token) {
        try {
            navigate('/checkout', { state: book });

        } catch (error) {
            console.log("Failed to add to cart. Please login or try again.");
        }} else {
            navigate("/login")
        }
    };

  
        const handleAddToCart = async (bookId) => {
    
            if (isLoggedIn && token) {
                try {
                    await addtoCart({ bookId, quantity: 1 });
                    navigate('/cart');
                } catch (error) {
                    alert("Failed to add to cart. Please login or try again.");
                }
            } else {
                navigate("/login")
            }
        };
    // Fetch category name for heading
    useEffect(() => {
        const getCategoryName = async () => {
            const data = await fetchCategories();
            // If you use subcategory id in URL
            let found = null;
            data.forEach(cat => {
                if (cat.subCategories) {
                    const sub = cat.subCategories.find(s => String(s.id) === String(subCategoryId) || s.name === subCategoryId);
                    if (sub) {
                        found = cat.name;
                    }
                }
            });
            setCategoryName(found || "");
        };
        if (subCategoryId) getCategoryName();
    }, [subCategoryId]);

    return (
        <Container maxWidth='xl' >
            <Box sx={{ display: 'flex', flexDirection: isSmallScreen ? 'column' : 'row', gap: '20px', mt: 4 }}>
                <Box sx={{ width: isSmallScreen ? '100%' : '25%' }}>
                    <Filter />
                </Box>
                <Box sx={{ width: isSmallScreen ? '100%' : '75%' }}>
                    <>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5} >
                            <Typography
                                variant="h3"
                                sx={{
                                    fontWeight: 600,
                                    fontFamily: 'Poppins',
                                    color: '#CB4422',
                                    borderLeft: '4px solid #000000',
                                    paddingLeft: 1,
                                }}
                            >
                                {categoryName || "Books"}
                            </Typography>
                            
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 2,
                                justifyContent:{xs:'center' , md: 'flex-start'},
                                pb: 1,
                                '&::-webkit-scrollbar': { display: 'none' },
                                '-ms-overflow-style': 'none',
                                'scrollbar-width': 'none',
                            }}
                        >
                            {books.filter(book => book.isActive).map((book) => (
                                <Box
                                    key={book.id}
                                    sx={{
                                        minWidth: { xs: 250, sm: 200, md: 250, lg: 225 },
                                        maxWidth: { xs: 180, sm: 200, md: 250, lg: 225 },
                                        flex: '1 1 225px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                     
                                    }}
                                >
                                    <Card
                                        sx={{
                                            width: '100%', // Ensures card takes full width of Box
                                            height: { xs: 340, sm: 360, md: 370 },
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            boxShadow: 'none',
                                            border: '1px solid lightgrey',
                                            position: 'relative', // Added this line
                                        }}
                                    >
                                        {/* Discount badge */}
                                        {book.discountOffer > 0 && (
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: 8,
                                                    left: 0,
                                                    bgcolor: 'black',
                                                    color: 'white',
                                                    px: 1,
                                                    py: 0.5,
                                                    fontSize: '12px',
                                                    zIndex: 2,
                                                    borderRadius: 0.5,
                                                }}
                                            >
                                                {book.discountOffer}% off
                                            </Box>
                                        )}
                                        {/* Shopping Cart icon */}
                                        <IconButton  
                                            onClick={() => handleAddToCart(book.id)} 
                                            disableRipple 
                                            disableFocusRipple
                                            disabled={!book.availability}
                                            sx={{ 
                                                position: 'absolute', 
                                                top: 8, 
                                                right: 8, 
                                                zIndex: 2, 
                                                bgcolor: '#FFB300', 
                                                color: '#000',
                                                '&.Mui-disabled': {
                                                    opacity: 0.7,
                                                },
                                            }}
                                        >
                                            <i className="fa-solid fa-cart-shopping" style={{ fontSize: '14px', color: 'black' }}></i>
                                        </IconButton>
                                        
                                        {/* Out of Stock Overlay */}
                                        {!book.availability && (
                                            <Box sx={{
                                                position: 'absolute',
                                                left: 0,
                                                top: 0,
                                                width: '100%',
                                                height: '100%',
                                                bgcolor: 'rgba(180, 180, 180, 0.25)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                pointerEvents: 'none',
                                                zIndex: 1,
                                                '&:before': {
                                                    content: '"OUT OF STOCK"',
                                                    position: 'absolute',
                                                    fontWeight: 700,
                                                    fontSize: 24,
                                                    color: '#dc0000',
                                                    letterSpacing: 2,
                                                    
                                                    padding: '4px 12px',
                                                    borderRadius: 1,
                                                    
                                                }
                                            }} />
                                        )}
                                        {/* Book Image */}
                                              <Box sx={{width:'100%' , height :'70%' , display:'block', position:'relative'}}>
<CardMedia
                                            component="img"
                                            loading="lazy"
                                            onClick={() => navigate(`/book-overview/${book.id}`)}
                                            sx={{
                                                width: '100%',      // Image takes full card width
                                                height: "100%",        // Fixed image height
                                                objectFit: 'stretch', // Ensures image covers the area
                                                display: 'block',
                                            }}
                                            image={book.bookImages?.[0]?.imageUrl || ''}
                                            alt={book.title}
                                        />
                                              </Box>
                                        
                                        <CardContent sx={{ textAlign: 'center' }}>
                                            {/* Title */}
                                            <Typography variant="body1" fontWeight="bold" noWrap sx={{ my: 0 }}>
                                                {book.title}
                                            </Typography>
                                            {/* Yearly & Author */}
                                            <Typography fontSize={10} variant="caption" color="text.secondary"  >
                                                Yearly - {book.publishingYear}, by {book.author?.name || "Unknown Author"}
                                            </Typography>
                                            {/* Rating */}
                                           
                                            {/* Price and Buy Now */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1 }} >
                                                <Typography variant="h6" color="#000">
                                                    ₹{(book.price - (book.price * (book.discountOffer || 0) / 100)).toFixed(2)}
                                                </Typography>
                                                <Button 
                                                    variant="contained" 
                                                    size="small"
                                                    disabled={!book.availability}
                                                    sx={{
                                                        textTransform: 'none', 
                                                        fontSize: '10px', 
                                                        borderRadius: '2px', 
                                                        px: 2, 
                                                        boxShadow: 'none',
                                                        backgroundColor: '#D44F1C',
                                                        '&:hover': {
                                                            backgroundColor: '#b93d13',
                                                            boxShadow: 'none',
                                                        },
                                                        '&.Mui-disabled': {
                                                            backgroundColor: '#D44F1C',
                                                            color: '#fff',
                                                            opacity: 0.7,
                                                        },
                                                        
                                                    }} onClick={() => handleBuyNow(book)}
                                                >
                                                    Buy Now
                                                </Button>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Box>
                            ))}
                        </Box>
                    </>
                </Box>
            </Box>
        </Container>
    )
}

export default FilteredBooks;